import { useColumnsOrganizationUsers } from 'Hooks/useColumnsOrganizationUsers';
import { useState } from 'react';
import LocalStorage from 'Tools/localStorage';
import { OrganizationPersonOrder } from 'Apollo';
import UsersTableBase, { UsersTableBaseProps } from './UsersTableBase';

type OrganizationUsersTableProps = Omit<
  UsersTableBaseProps<OrganizationPersonOrder>,
  | 'activeColumns'
  | 'onChangeColumns'
  | 'onResetColumns'
  | 'toolbarLeftContent'
  | 'canDeleteUsers'
  | 'canSubscribeUsers'
  | 'canInviteUsers'
> & {
  organizationCode?: string;
};

function OrganizationUsersTable(props: Readonly<OrganizationUsersTableProps>) {
  const defaultOrgColumns = useColumnsOrganizationUsers();
  const [orgColumns, setOrgColumns] = useState(
    LocalStorage.deserializeColumns(
      defaultOrgColumns,
      LocalStorage.OrganizationUsersColumns ?? []
    )
  );

  const onChangeColumns = (newColumns: any) => {
    setOrgColumns(newColumns);
    LocalStorage.OrganizationUsersColumns = LocalStorage.serializeColumns(newColumns);
  };

  const onResetColumns = () => {
    LocalStorage.OrganizationUsersColumns = null;
    setOrgColumns(defaultOrgColumns);
  };

  return (
    <UsersTableBase
      {...props}
      activeColumns={orgColumns}
      onChangeColumns={onChangeColumns}
      onResetColumns={onResetColumns}
      canDeleteUsers={true}
      canSubscribeUsers={false}
      canInviteUsers={false}
    />
  );
}

export default OrganizationUsersTable;
